import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Grid2 from '@mui/material/Grid2';
import { useState } from 'react';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';

const Saulo = () => {
    
const [activeImage, setActiveImage] = useState(0);

    return (
        <div className="container-pg">
            <div className="header-container" id='home'>
                <img className="logoTopo" src="/Images/sigma.png" alt='logo'/>
                <div className="header-menu">
                    <ul className="navbar">
                        <li><a href="https://sigmasystems.com.br">HOME</a></li>
                        {/* <li><a href="https://sigmasystems.com.br">BENEFÍCIOS</a></li>
                        <li><a href="https://sigmasystems.com.br">FUNCIONALIDADES</a></li>
                        <li><a href="https://sigmasystems.com.br">PORTFÓLIO</a></li> */}
                        <li><a href="https://sigmasystems.com.br/saulo">S.A.U.L.O.</a></li>
                    </ul>
                    <a href='https://wa.me/+5545991166770' style={{textDecoration:'none', color:'#000',}}><button className="header-btn">ORÇAMENTO</button></a>
                </div>
            </div>
            <div className="container-banner">
                <div className="banner-bg">
                    <div className="content-banner" style={{paddingBottom:'50px'}}>
                        <div className="banner-subTitle">S.A.U.L.O.</div>
                        <hr className="line1"/>
                        <div className="banner-subTitle2"><strong>S</strong>olução em <strong>A</strong>utomação <strong>U</strong>nificada de <strong>L</strong>eads <strong>O</strong>timizadas</div>
                        <img className='banner-bot' src='/Images/bot-3d.png'/>
                        <span className='banner-title' style={{zIndex:2}}>Venda mais, atenda melhor</span>
                        <span className="banner-title" style={{color:'#699934',marginTop:0, zIndex:2}}>e conquiste o cliente</span>
                        <div className="banner-subtitle" style={{color:'#4D4D4D', zIndex:2}}>Uma plataforma completa de <strong>CRM</strong>, <strong>atendimento</strong> e <strong>automação</strong> com<br/> <strong>Inteligência Artificial</strong></div>
                        <div className="banner-infos" style={{zIndex:2}}>
                            <div className="banner-info-brick">
                                <div className="banner-info-iconBg">
                                    <img src='/Images/grow.svg' className='banner-info-icon'/>
                                </div>
                                <span className='banner-info-text'>Aumente seu faturamento</span>
                            </div>
                             <div className="banner-info-brick">
                                <div className="banner-info-iconBg">
                                    <img src='/Images/clock.svg' className='banner-info-icon'/>
                                </div>
                                <span className='banner-info-text'>Atendimento agilizado</span>
                            </div>
                             <div className="banner-info-brick">
                                <div className="banner-info-iconBg">
                                    <img src='/Images/dolar.svg' className='banner-info-icon'/>
                                </div>
                                <span className='banner-info-text'>Conversão de Leads</span>
                            </div>
                        </div>
                        <div className="banner-btns" style={{zIndex:2}}>
                            <a href='https://wa.me/+5545991166770' style={{textDecoration:'none', color:'#000'}}>
                                <button className="banner-btn-left">Pedir Orçamento <WhatsAppIcon sx={{marginLeft:1, fontSize:32}}/></button>
                            </a>
                            <button className="banner-btn-right">Conhecer Mais</button>
                        </div>
                        <img className="mask" src="/Images/mask.svg" alt='background-banner'/>
                    </div>
                </div>
            </div>
            <div className="block-container">
                <div className="block-content">
                    <div className="block1-images-container" style={{marginTop:0}}>
                        <div className="block1-images-content">
                            <div className="block1-images-slider">
                                <img src="/Images/crm1.png" className="block1-images" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="block-container">
                <div className="block-content">
                    <div className="block-top">
                        <img src='/Images/robot.svg' className='block-top-icon'/>
                        <span className='block-top-text'>AGENTE DE IA</span>
                    </div>
                    <div className="block-header">
                        <span className='block-title' style={{marginTop:10}}>Agente de IA <span style={{color:'#699934'}}>que realmente resolve</span></span>
                        <span className='block-text' style={{marginTop:10}}>Não é um chatbot simples. É um agente inteligente que entende seu negócio e<br/>executa ações no seu CRM - 24h por dia.</span>
                    </div>
                    <Grid2 container spacing={2} justifyContent={'center'} className='from-bottom' sx={{marginTop:'60px'}} >
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/person-check.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Inteligência de Verdade</div>
                                <div className="block1-text">Responde como seu melhor vendedor. Entende contexto, tom de voz e sabe quando transferir para um humano.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/clock.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Atende 24h, Sem Parar</div>
                                <div className="block1-text">Seus clientes nunca ficam sem resposta. O agente trabalha de madrugada, feriado e final de semana.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/microfone.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Entende Áudio e Imagem</div>
                                <div className="block1-text">Seu cliente manda um áudio? Uma foto do produto? O agente transcreve, analisa e responde na hora.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/image.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Aprende com Seu Negócio</div>
                                <div className="block1-text">Treine o agente com seus documentos, catálogos e FAQs. Ele responde com a informação certa, sempre.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/globe.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Links Externos de Conhecimento</div>
                                <div className="block1-text">Conecte sites, páginas de produto e centrais de ajuda. O agente consulta fontes externas em tempo real para dar respostas completas.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/book.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Base de Conhecimento (RAG)</div>
                                <div className="block1-text">Upload de PDFs, planilhas e documentos. O agente busca a informação certa por contexto, não por palavra-chave.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/stars.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Personalidade da Sua Empresa</div>
                                <div className="block1-text">Configure tom de voz, regras e limites. O agente conversa com a cara do seu negócio, não como um robô.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/robot2.svg' style={{fill:'#000'}} className='block1-icon'/>
                                </div>
                                <div className="block1-title">Multi-Modelo de IA</div>
                                <div className="block1-text">Funciona com GPT, Claude e Gemini. Escolha o modelo ideal para cada situação e otimize seus resultados.</div>
                            </div>
                        </Grid2>
                    </Grid2>
                    <div className="iobwca">
                        <div className="iobwca-content">
                            <div className="iobwca-header">
                                <div className="iobwca-header-iconBg">
                                    <img src='/Images/grow.svg' className='iobwca-header-icon'/>
                                </div>
                                <div className="iobwca-header-text">
                                    <span className="iobwca-title">Ações Inteligentes - o agente não só responde, ele age</span>
                                    <span className="iobwca-subTitle">Durante a conversa, o agente executa ações reais no seu sistema. Sem intervenção humana.</span>
                                </div>
                            </div>
                            <Grid2 container spacing={2}  className='from-bottom iobwca-grid' sx={{marginTop:'20px'}} >
                                <Grid2 item>
                                    <div className="iobwca-card">
                                        <div className="block1-iconBg">
                                            <img src='/Images/tag.svg' className='block1-icon'/>
                                        </div>
                                        <div className="iobwca-card-title">Aplicar e remover tags no contato</div>
                                    </div>
                                </Grid2>
                                <Grid2 item>
                                    <div className="iobwca-card">
                                        <div className="block1-iconBg">
                                            <img src='/Images/person-check.svg' className='block1-icon'/>
                                        </div>
                                        <div className="iobwca-card-title">Transferir para atendente ou departamento</div>
                                    </div>
                                </Grid2>
                                <Grid2 item>
                                    <div className="iobwca-card">
                                        <div className="block1-iconBg">
                                            <img src='/Images/send.svg' className='block1-icon'/>
                                        </div>
                                        <div className="iobwca-card-title">Enviar mensagem, mídia ou menu interativo</div>
                                    </div>
                                </Grid2>
                                <Grid2 item>
                                    <div className="iobwca-card">
                                        <div className="block1-iconBg">
                                            <img src='/Images/raio.svg' className='block1-icon'/>
                                        </div>
                                        <div className="iobwca-card-title">Criar ticket de atendimento</div>
                                    </div>
                                </Grid2>
                                <Grid2 item>
                                    <div className="iobwca-card">
                                        <div className="block1-iconBg">
                                            <img src='/Images/connection.svg' className='block1-icon'/>
                                        </div>
                                        <div className="iobwca-card-title">Disparar webhook para sistema externo</div>
                                    </div>
                                </Grid2>
                                <Grid2 item>
                                    <div className="iobwca-card">
                                        <div className="block1-iconBg">
                                            <img src='/Images/arrow-right.svg' className='block1-icon'/>
                                        </div>
                                        <div className="iobwca-card-title">Mover card no pipeline do CRM</div>
                                    </div>
                                </Grid2>
                            </Grid2>
                        </div>
                    </div>
                    <div className="block1-images-container">
                        <div className="block1-images-content">
                            <div className="block1-images-slider" style={{transform: `translateX(-${activeImage * 100}%)`}}>
                                <img src="/Images/img1.png" className="block1-images" />
                                <img src="/Images/img2.png" className="block1-images" />
                                <img src="/Images/img3.png" className="block1-images" />
                            </div>
                            <div className="block1-images-dots">
                                {[0, 1, 2].map((index) => (
                                    <div key={index} className={`block1-dots ${activeImage === index ? 'dot-active' : ''}`} onClick={() => setActiveImage(index)} />
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="block-container">
                <div className="block-content">
                    <div className="block-top">
                        <img src='/Images/raio2.svg' className='block-top-icon'/>
                        <span className='block-top-text'>AUTOMAÇÕES</span>
                    </div>
                    <div className="block-header">
                        <span className='block-title' style={{marginTop:10}}>Coloque suas vendas <span style={{color:'#699934'}}>no piloto automático</span></span>
                        <span className='block-text' style={{marginTop:10}}>Monte fluxos de automação arrastando e soltando. Responda Leads em segundos,<br/>qualifique automaticamente e nunca perca uma oportunidade de venda.</span>
                    </div>
                    <div className="automation-content">
                        <div className="automation-block">
                            <span className='automation-block-title'>O que dispara a automação</span>
                            <span className='automation-block-text'>Escolha o evento que incia o fluxo</span>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/conversation.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Nova mensagem recebida</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/tag.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Lead marcado com tag</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/cart.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Compra no Shopify ou Hotmart</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/form.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Novo lead via formulário</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/insta.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Comentário no Instagram</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/list.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Atendimento na fila</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/robot2.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Resposta do agente de IA</span>
                            </div>
                        </div>
                        <div className="automation-block">
                            <span className='automation-block-title'>O que acontece automaticamente</span>
                            <span className='automation-block-text'>Defina as ações que o sistema executa sozinho</span>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/send.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Enviar mensagem automática</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/lupa.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Criar ticket de atendimento</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/link.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Notificar sistema externo</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/tag.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Organizar e segmentar leads</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/robot2.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Acionar agente de IA</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/if.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Decisões inteligentes (se/não)</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/randon.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Teste A/B automáticos</span>
                            </div>
                            <div className="automation-brick"> 
                                <div className="block1-iconBg">
                                    <img src='/Images/timer.svg' className='block1-icon'/>
                                </div>
                                <span className='automation-brick-title'>Follow-ups programados</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="block-container">
                <div className="block-content">
                    <div className="block-top">
                        <img src='/Images/canais.svg' className='block-top-icon'/>
                        <span className='block-top-text'>CANAIS</span>
                    </div>
                    <div className="block-header">
                        <span className='block-title' style={{marginTop:10}}>Venda pelo WhatsApp e Instagram <span style={{color:'#699934'}}>como nunca antes</span></span>
                        <span className='block-text' style={{marginTop:10}}>Seus dois canais mais poderosos, integrados em uma única tela.</span>
                    </div>
                    <div className="canais-content">
                        <div className="canais-block1">
                            <div className="canais-brick1">
                                <div className="canais-brick1-header">
                                    <img src='/Images/wpp.svg' className='canais-icon'/>
                                    <span className='canais-brick1-title'>WhatsApp</span>
                                </div>
                                <div className="canais-brick1-lines">
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Vários números em uma única tela</span>
                                    </div>
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Envio de campanhas e mensagens em massa</span>
                                    </div>
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Mensagens agendadas para follow-up perfeito</span>
                                    </div>
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Distribuição automática entre atendentes</span>
                                    </div>
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Transferência inteligente entre departamentos</span>
                                    </div>
                                </div>
                            </div>
                            <div className="canais-brick1">
                                <div className="canais-brick1-header">
                                    <img src='/Images/instagram.svg' className='canais-icon'/>
                                    <span className='canais-brick1-title'>Instagram</span>
                                </div>
                                <div className="canais-brick1-lines">
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Responde Direct Messages sem sair da plataforma</span>
                                    </div>
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Automação por comentários em post e reels</span>
                                    </div>
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Captura automática de leade de stories</span>
                                    </div>
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Qualificação de leades com IA integrada</span>
                                    </div>
                                    <div className="canais-brick1-line">
                                        <img src='/Images/small-arrow.svg' className='canais-arrow'/>
                                        <span className='canais-brick1-text'>Gatilhos inteligentes nos fluxos de automação</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Grid2 container spacing={1}  className='from-bottom canais-block2'>
                            <Grid2 item>
                                <div className="canais-brick2-card">
                                    <div className="canais-brick2-iconBg">
                                        <img src='/Images/cart2.svg' className='canais-brick2-icon'/>
                                    </div>
                                    <span className='canais-brick2-title'>Venda Mais</span>
                                    <span className='canais-brick2-text'>Transforme conversas em vendas. Qualifique leads, envie catálogos e feche negócios direto no chat.</span>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="canais-brick2-card">
                                    <div className="canais-brick2-iconBg">
                                        <img src='/Images/headphone.svg' className='canais-brick2-icon'/>
                                    </div>
                                    <span className='canais-brick2-title'>Atenda Melhor</span>
                                    <span className='canais-brick2-text'>Filas inteligentes, SLA automático e transferência perfeita. Seus clientes nunca esperam demais.</span>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="canais-brick2-card">
                                    <div className="canais-brick2-iconBg">
                                        <img src='/Images/person-check2.svg' className='canais-brick2-icon'/>
                                    </div>
                                    <span className='canais-brick2-title'>Capture Leads</span>
                                    <span className='canais-brick2-text'>IA que qualifica leads antes de chegar no seu time. Só receba contatos prontos para comprar.</span>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="canais-brick2-card">
                                    <div className="canais-brick2-iconBg">
                                        <img src='/Images/bullseyes.svg' className='canais-brick2-icon'/>
                                    </div>
                                    <span className='canais-brick2-title'>Organize Tudo</span>
                                    <span className='canais-brick2-text'>Tickets com protocolo, histórico completo e rastreabilidade total. Nunca perca uma conversa.</span>
                                </div>
                            </Grid2>
                        </Grid2>
                    </div>
                </div>
            </div>
            <div className="block-container">
                <div className="block-content">
                    <div className="block-top">
                        <img src='/Images/shield.svg' className='block-top-icon'/>
                        <span className='block-top-text'>INTELIGÊNCIA ARTIFICIAL SÉRIA</span>
                    </div>
                    <div className="block-header">
                        <span className='block-title' style={{marginTop:10}}>IA que executa, <span style={{color:'#699934'}}>não só responde</span></span>
                        <span className='block-text' style={{marginTop:10}}>Nada de chatbot de menuzinho. O agente da Sigma toma ações reais na sua operação, do<br/>primeiro oi até a reunião marcada.</span>
                    </div>
                    <Grid2 container spacing={2} justifyContent={'center'} className='from-bottom' sx={{marginTop:'60px'}} >
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/microfone.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Entende áudios</div>
                                <div className="block1-text">Cliente mandou áudio? O agente transcreve e responde na hora, sem pedir para digitar.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/image.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Lê imagens</div>
                                <div className="block1-text">Comprovantes, fotos de produto, prints - o agente analisa a imagem e segue a conversa.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/calendar.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Agenda de verdade</div>
                                <div className="block1-text">Consulta horários livres, marca, remarca e cancela reuniões no Google Calendar — com trava anti-conflito de horário.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/funil.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Move o funil</div>
                                <div className="block1-text">Cria negócios no CRM, muda leads de etapa e aplica tags conforme a conversa evolui.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/person.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Sabe a hora de sair</div>
                                <div className="block1-text">Transfere para o atendente humano certo, na fila certa, quando a conversa precisa de gente.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/book.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Treinada no seu negócio</div>
                                <div className="block1-text">Base de conhecimento com PDF, Word, planilhas, Google Sheets e até a resposta das suas APIs.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/globe.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Conversa com seus sistemas</div>
                                <div className="block1-text">O agente chama as APIs da sua empresa durante o atendimento: consulta pedido, estoque, cadastro - o que você precisar.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="block1-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/robot2.svg' style={{fill:'#000'}} className='block1-icon'/>
                                </div>
                                <div className="block1-title">Multi-Modelo de IA</div>
                                <div className="block1-text">Funciona com GPT, Claude e Gemini. Escolha o modelo ideal para cada situação e otimize seus resultados.</div>
                            </div>
                        </Grid2>
                    </Grid2>
                </div>
            </div>
            <div className="block-container">
                <div className="block-content">
                    <div className="block-top">
                        <img src='/Images/crm.svg' className='block-top-icon'/>
                        <span className='block-top-text'>CRM COMPLETO</span>
                    </div>
                    <div className="block-header">
                        <span className='block-title' style={{marginTop:10}}>Feche mais negócios <span style={{color:'#699934'}}>com menos esforço</span></span>
                        <span className='block-text' style={{marginTop:10}}>Pare de perder vendas por falta de organização. Acompanhe cada negociação do<br/>primeiro contato até o fechamento.</span>
                    </div>
                    <div className="block1-images-container">
                        <div className="block1-images-content">
                            <div className="block1-images-slider" style={{transform: `translateX(-${activeImage * 100}%)`}}>
                                <img src="/Images/crm.png" className="block1-images" />
                            </div>
                        </div>
                    </div>
                    <Grid2 container spacing={2} justifyContent={'center'} className='from-bottom' sx={{marginTop:'60px'}} >
                        <Grid2 item>
                            <div className="crm-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/pipeline.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Pipeline Visual</div>
                                <div className="block1-text">Veja todas as suas negociações em um quadro Kanban. Arraste e solte para avançar cada deal.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="crm-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/pedidos.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Pedidos Organizados</div>
                                <div className="block1-text">Crie pedidos com valores, produtos e histórico. Saiba exatamente quanto está em jogo em cada negociação.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="crm-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/followups.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Nunca Perca um Follow-up</div>
                                <div className="block1-text">Cadência de tarefas automática. O sistema lembra sua equipe de ligar, enviar proposta ou fazer reunião.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="crm-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/autopipeline.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Automação no Pipeline</div>
                                <div className="block1-text">Quando um card muda de etapa, ações disparam automaticamente: notificações, mensagens, atribuições.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="crm-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/produtos.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Catálogo de Produtos</div>
                                <div className="block1-text">Cadastre seus produtos com preço. Vincule aos negócios e calcule valores na hora.</div>
                            </div>
                        </Grid2>
                        <Grid2 item>
                            <div className="crm-card">
                                <div className="block1-iconBg">
                                    <img src='/Images/person.svg' className='block1-icon'/>
                                </div>
                                <div className="block1-title">Gestão de Contatos</div>
                                <div className="block1-text">Tudo sobre seu lead em um só lugar: histórico de conversas, tags, campos personalizados e jornada.</div>
                            </div>
                        </Grid2>
                    </Grid2>
                </div>
            </div>
            <div className="block-container">
                <div className="block-content">
                    <div className="block-header">
                        <span className='block-title' style={{marginTop:10}}>Pronto para transformar<span style={{color:'#699934'}}><br/>seu negócio?</span></span>
                        <span className='block-text' style={{marginTop:10}}>Melhore seu atendimento e faturamento <strong>agora!</strong></span>
                    </div>
                    <a href='https://wa.me/+5545991166770' style={{textDecoration:'none', color:'#000', marginTop:'30px', marginBottom:'60px'}}>
                        <button className="banner-btn-left">Pedir Orçamento <WhatsAppIcon sx={{marginLeft:1, fontSize:32}}/></button>
                    </a>
                </div>
            </div>
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-left">
                        <img src='/Images/sigma.png' className='footer-logo' alt='logo'></img>
                        <div className='follow-us'>Siga-nos nas redes sociais!</div>
                        <div className='social-media'>
                            <a href='https://instagram.com/sigmasystemsbr'><button className='rs-icon'><InstagramIcon sx={{fontSize:32, color:'#FFF'}}/></button></a>
                            <a href='https://facebook.com/sigmasystemsbr' style={{marginInline:10}}><button className="rs-icon"><FacebookRoundedIcon sx={{fontSize:32, color:'#FFF'}}/></button></a>
                            <a href='https://wa.me/+5545991166770'><button className="rs-icon"><WhatsAppIcon sx={{fontSize:32, color:'#FFF'}}/></button></a>
                        </div>
                    </div>
                    <div className="footer-right">
                        <div className="footer-contato">
                            <div className="footer-title">Contato</div>
                            <div className='footer-text'>WhatsApp<br/><strong>(45) 99116-6770</strong></div>
                        </div>
                        <div className="footer-adress">
                            <div className="footer-title">Endereço</div>
                            <div className='footer-text'>Em breve...</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-down">© 2026 - Sigma System - Todos os direitos reservados</div>
        </div>
    )
}
export default Saulo;